import React, { useState, useEffect } from "react";
import AudioReactRecorder, { RecordState } from "audio-react-recorder";
import { ReactComponent as MicIcon } from "assets/img/icons/mic.svg";
import { ReactComponent as CircleIcon } from "assets/img/icons/circle-fill.svg";
import { ReactComponent as PlayIcon } from "assets/img/icons/play-fill.svg";
import { ReactComponent as PauseIcon } from "assets/img/icons/pause.svg";
import classNames from "classnames";
import * as moment from "moment";

const styles = {
  root: {
    backgroundColor: "black",
    position: "relative",
  },
  startRecordContainer: {
    position: "absolute",
    top: "25%",
    display: "flex",
    justifyContent: "center",
    width: "100%",
  },
  micIcon: {
    fill: "white",
    height: "128px",
    width: "40px",
  },
  recordBar: {
    backgroundColor: "#1e242c",
    height: "30px",
    maxHeight: "30px",
  },
  recordBarRoot: {
    display: "flex",
    gap: "5px",
    height: "100%",
  },
  recordBarContent: {
    display: "flex",
    width: "25px",
    alignItems: "center",
    justifyContent: "center",
    marginLeft: "5px",
  },
  icon: {
    width: "14px",
    height: "14px",
    fill: "white",
  },
  pauseIconContainer: {
    display: "flex",
    width: "25px",
    alignItems: "center",
    justifyContent: "center",
  },
  playIconContainer: {
    display: "flex",
    width: "25px",
    alignItems: "center",
    justifyContent: "center",
  },
};

export default ({ onChange = () => { }, type }) => {
  const classes = styles;
  const [recordState, setRecordState] = useState(null);
  const [recordTimer, setRecordTimer] = useState(null);
  const [startRecord, setStart] = useState(false);
  const [disabledButton, setDButton] = useState(true);

  useEffect(() => {
    if(!recordState) return;

    if(recordState) {

      setTimeout(() => {
        setDButton(false);
      }, 1000);
    }

  },[recordState])

  const [timer, setTimer] = useState(
    moment().set({
      hour: 0,
      minute: 0,
      second: 0,
      millisecond: 0,
    })
  );
  const [pauseRecord, setPauseRecord] = useState(false);
  const [timerId, setTimerId] = useState(null);


  useEffect(() => {

    (async() => {
      await navigator.mediaDevices.getUserMedia({
        audio: true,
      });
    })();

    return () => {
      setRecordState(null);
    };
  }, []);

  useEffect(() => {
    if (!startRecord) {
      return;
    }

    if (pauseRecord) {
      setTimer(timer);
      return;
    }

    if (!pauseRecord) {
      setTimerId(
        setInterval(function () {
          setRecordTimer(timer.utc().format("mm:ss"));
          timer.add(1, "s");
        }, 1000)
      );
    }

    return () => {
      clearInterval(timerId);
    };

    //eslint-disable-next-line
  }, [startRecord, pauseRecord]);

  const pause = () => {
    setRecordState(RecordState.PAUSE);
    setPauseRecord(!pauseRecord);
    clearInterval(timerId);
  };

  const start = () => {
    setRecordState(RecordState.START);
    if (!pauseRecord) {
      setStart(true);
    }

    if (pauseRecord) {
      setPauseRecord(false);
    }
  };

  const stop = () => {
    setRecordState(RecordState.STOP);
  };

  const onStop = (audioData) => {
    setStart(false);

    var newRecordData = new File(
      [audioData.blob],
      `${new Date().getTime()}.mp3`,
      {
        type: "audio/mp3",
      }
    );
    onChange(newRecordData);
  };

  return (
    <div style={classes.root}>
      <AudioReactRecorder
        canvasWidth={"100%"}
        backgroundColor={"black"}
        foregroundColor={"#36393b"}
        state={recordState}
        onStop={onStop}
        type={"audio/mp3"}
      />
      {!startRecord && (
        <div style={classes.startRecordContainer}>
          <div className="audioRecorderButton" onClick={start}>
            <MicIcon style={classes.micIcon} />
          </div>
        </div>
      )}
      <div style={classes.recordBar}>
        {startRecord && (
          <div style={classes.recordBarRoot}>
            <div style={classes.recordBarContent}>
              <CircleIcon
                className={classNames({
                  "disabled-audio-btn": disabledButton,
                })}
                onClick={stop} style={classes.icon} />
            </div>
            {!pauseRecord && (
              <div style={classes.pauseIconContainer}>
                <PauseIcon className={classNames({
                  "disabled-audio-btn": disabledButton,
                })} onClick={pause} style={classes.icon} />
              </div>
            )}
            {pauseRecord && (
              <div style={classes.playIconContainer}>
                <PlayIcon className={classNames({
                  "disabled-audio-btn": disabledButton,
                })} onClick={start} style={classes.icon} />
              </div>
            )}
            <div
              style={{ display: "flex", alignItems: "center", color: "white" }}
            >
              {recordTimer}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
